export default {
  googleAuthorizeTerms: "Quest’app non sarà più supportata dopo il 10 marzo 2023. Installa la nostra nuova versione di {googleAppName}."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
